import React, { useState } from "react";
import "../../custom.css";
import { useSelector } from "react-redux";
import convertMoney from "../../convertMoney";
import { isNotEmpty, isEmail } from "../../Authentication/util/validation";
export default function CheckoutPage() {
  const listCart = useSelector((state) => state.cart.listCart);
  // Tính tổng giá trị đơn hàng
  const total = listCart.reduce(
    (acc, item) => acc + item.product.price * item.quantity,
    0
  );
  //validate form
  const [enterValue, setEnterValue] = useState({
    fullname: "",
    email: "",
    phone: "",
    address: "",
  });
  const [errors, setErrors] = useState({});
  //hàm lấy dữ liệu
  function handleValueChange(id, value) {
    setEnterValue((pre) => ({
      ...pre,
      [id]: value,
    }));
  }
  //hàm validate
  function validateForm() {
    const newErrors = {};
    if (!isNotEmpty(enterValue.fullname)) {
      newErrors.fullName = "Please enter your fullname.";
    }
    if (!isEmail(enterValue.email) || !isNotEmpty(enterValue.email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (!isNotEmpty(enterValue.phone)) {
      newErrors.phone = "Please enter your phone.";
    }
    if (!isNotEmpty(enterValue.address)) {
      newErrors.address = "Please enter your address.";
    }
    return newErrors;
  }
  //hàm submit order
  function handlerSubmitOrder(e) {
    e.preventDefault();
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      alert("Your order submmited!");
    }
    setEnterValue({
      fullname: "",
      email: "",
      phone: "",
      address: "",
    });
  }

  return (
    <div className="container fst-italic">
      <section className="py-5 bg-light container-shop">
        <div className="container">
          <div className="row px-4 px-lg-5 py-lg-4 align-items-center">
            <div className="col-lg-6">
              <h1 className="h2 text-uppercase mb-0">Checkout</h1>
            </div>
            <div className="col-lg-6 text-lg-right">
              <nav aria-label="breadcrumb" className="text-uppercase">
                <ol className=" breadcrumb justify-content-lg-end mb-0 px-0">
                  <li className="breadcrumb-item ">
                    <a className="nav-checkout" href="/">
                      Home
                    </a>
                  </li>
                  <li className="breadcrumb-item">
                    <a className="nav-checkout" href="/cart">
                      Cart
                    </a>
                  </li>
                  <li
                    className="breadcrumb-item nav-checkout active"
                    aria-current="page"
                  >
                    Checkout
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="row">
          <h4 className="text-uppercase mb-4 px-3 h4-checkout">
            billing details
          </h4>
          <div className="col-lg-8 mb-4 px-3">
            <form
              className="text-muted form-checkout"
              onSubmit={handlerSubmitOrder}
            >
              <div className="d-flex flex-column mb-3">
                <label className="text-uppercase mb-2">full name</label>
                <input
                  type="text"
                  placeholder="Enter Your Full Name Here!"
                  id="fullname"
                  value={enterValue.fullname}
                  onChange={(e) =>
                    handleValueChange("fullname", e.target.value)
                  }
                />
                {errors.fullName && (
                  <div className="error-text">{errors.fullName}</div>
                )}
              </div>
              <div className="d-flex flex-column mb-3">
                <label className="text-uppercase mb-2">email</label>
                <input
                  type="text"
                  placeholder="Enter Your Email Here!"
                  id="email"
                  value={enterValue.email}
                  onChange={(e) => handleValueChange("email", e.target.value)}
                />
                {errors.email && (
                  <div className="error-text">{errors.email}</div>
                )}
              </div>
              <div className="d-flex flex-column mb-3">
                <label className="text-uppercase mb-2">phone number</label>
                <input
                  type="text"
                  placeholder="Enter Your phone number Here!"
                  id="phone"
                  value={enterValue.phone}
                  onChange={(e) => handleValueChange("phone", e.target.value)}
                />
                {errors.phone && (
                  <div className="error-text">{errors.phone}</div>
                )}
              </div>
              <div className="d-flex flex-column mb-3">
                <label className="text-uppercase mb-2">address</label>
                <input
                  type="text"
                  placeholder="Enter Your Address Here!"
                  id="address"
                  value={enterValue.address}
                  onChange={(e) => handleValueChange("address", e.target.value)}
                />
                {errors.address && (
                  <div className="error-text">{errors.address}</div>
                )}
              </div>
              <button type="submit">Place order</button>
            </form>
          </div>
          <div className="col-lg-4 px-4 py-4 order-checkout">
            <h4 className="text-uppercase h4-checkout mb-3"> your order</h4>
            {listCart.map((item) => (
              <div
                key={item.id}
                className="d-flex gap-2 border-bottom border-secondary"
              >
                <p className="text-order-checkout">{item.product.name}</p>
                <p className="flex-end mb-0 ms-auto text-muted">
                  {convertMoney(item.product.price)}VND x{item.quantity}
                </p>
              </div>
            ))}
            <div className="total-checkout d-flex">
              <p className="text-uppercase">total</p>
              <p className="flex-end ms-auto">{convertMoney(total)}VND</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
